module.exports = __webpack_public_path__ + "img/plat_4894.0350f8ff.jpg";